import { RefreshTokenResponse } from '../refreshtoken';
import { getServiceBaseUrl } from '../utils/api';

export async function refreshToken(cognitoUsername: string): Promise<RefreshTokenResponse> {
    const { baseUrl, stagingSuffix } = getServiceBaseUrl('authservice');
    const url = `${baseUrl}/refresh_token${stagingSuffix}?username=${encodeURIComponent(cognitoUsername)}`;

    const response = await fetch(
        url, {
        method: 'GET',
        credentials: 'include', // Necessary to send the HttpOnly cookie
    }
    );

    if (response.status !== 200) {
        throw new Error(`Unable to refresh token! Status: ${response.status}`);
    }

    const encodedByteString = await response.text();
    const decodedByteString = atob(encodedByteString);
    const decodedBytes = new Uint8Array(decodedByteString.length);
    for (let i = 0; i < decodedByteString.length; i++) {
        decodedBytes[i] = decodedByteString.charCodeAt(i);
    }

    return RefreshTokenResponse.decode(decodedBytes);
}
